import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonCs from './locales/cs/common.json';
import pagesCs from './locales/cs/pages.json';
import componentsCs from './locales/cs/components.json';

import commonEn from './locales/en/common.json';
import pagesEn from './locales/en/pages.json';
import componentsEn from './locales/en/components.json';

// Read saved language from localStorage for instant startup (before API loads)
const savedLang = localStorage.getItem('i18n_lang') || 'cs';

i18n.use(initReactI18next).init({
  lng: savedLang,
  fallbackLng: 'cs',
  supportedLngs: ['cs', 'en'],
  ns: ['common', 'pages', 'components'],
  defaultNS: 'common',
  resources: {
    cs: {
      common: commonCs,
      pages: pagesCs,
      components: componentsCs,
    },
    en: {
      common: commonEn,
      pages: pagesEn,
      components: componentsEn,
    },
  },
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

/**
 * Change language and persist to localStorage.
 * Call this from PreferencesTab when user switches language.
 */
export const changeLanguage = (lang: string) => {
  localStorage.setItem('i18n_lang', lang);
  return i18n.changeLanguage(lang);
};

export default i18n;
